export default "__VITE_ASSET__6d611e33__"